import { Filter, FilterPack } from '@/services/api/contracts/catalog/types';

type SharedFilterProperties = 'id' | 'effectiveDate' | 'modifier';

type CompositeFilter = Pick<Filter, SharedFilterProperties | 'category' | 'manufacturer'>;
type CategoryFilter = Pick<Filter, SharedFilterProperties | 'category'>;
type ManufacturerFilter = Pick<Filter, SharedFilterProperties | 'manufacturer'>;
type ProductFilter = Pick<Filter, SharedFilterProperties | 'daasCatalogItem'>;

interface Filters<T> {
  margin: T[];
  product: T[];
}

interface Organised {
  effectiveDate: Date;
  global: {
    margin: number;
  };

  composite: Filters<CompositeFilter>;
  category: Filters<CategoryFilter>;
  manufacturer: Filters<ManufacturerFilter>;
  individual: Filters<ProductFilter>;
}

export const organiseFilters = (pack: FilterPack): Organised => {
  const organised: Organised = {
    effectiveDate: pack.effectiveDate.value,
    global: {
      margin: pack.globalMarginModifier
    },
    composite: {
      margin: [],
      product: []
    },
    category: {
      margin: [],
      product: []
    },
    manufacturer: {
      margin: [],
      product: []
    },
    individual: {
      margin: [],
      product: []
    }
  };

  pack.marginFilters.forEach(filter => {
    if (filter.manufacturer && filter.category) {
      return organised.composite.margin.push(filter);
    }

    if (filter.manufacturer) {
      return organised.manufacturer.margin.push(filter);
    }

    if (filter.category) {
      return organised.category.margin.push(filter);
    }

    if (filter.daasCatalogItem) {
      return organised.individual.margin.push(filter);
    }
  });

  pack.productFilters.forEach(filter => {
    if (filter.manufacturer && filter.category) {
      return organised.composite.product.push(filter);
    }

    if (filter.manufacturer) {
      return organised.manufacturer.product.push(filter);
    }

    if (filter.category) {
      return organised.category.product.push(filter);
    }

    if (filter.daasCatalogItem) {
      return organised.individual.product.push(filter);
    }
  });

  return organised;
};
